import { useAEMIcons } from "@AEM/hooks/useAEMIcons"
import { useAEMDictionary } from "@AEM/hooks/useAEMDictionary"

export const usePreloadAEMContent = () => {
	// Preloading these resources to improve experience
	useAEMIcons()
	useAEMDictionary()
}
